// extracted by mini-css-extract-plugin
export default {"topic-card-footer-exclude-button":"TopicCardFooter_topic-card-footer-exclude-button__N8a81"};